import React, { useRef, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { validaMonto, formatMoneda, seleccionarCampo, formatoMonto, validaSoloNumero } from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';

export const IncluirMovimiento = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'))

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtIdMovimiento = useRef();
  const txtDescripcion = useRef();
  const txtFecha = useRef();
  const txtReferencia = useRef();
  const cmbTipoMovimiento = useRef();
  const txtMotivo = useRef();
  const txtMonto = useRef();

  const [body, setBody] = useState(null);
  const [operacion, setOperacion] = useState(0);
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

  const onChange = (e) => {

    if (e.target.name === 'motivo') {
      e.target.value = e.target.value;
    } else {
      e.target.value = e.target.value;
    }
  }

  const onChangeValidar = () => {

    let sigue = true;

    if (cmbTipoMovimiento.current.value === '') {
      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar el Tipo de Movimiento', icono: 'informacion' });
      cmbTipoMovimiento.current.focus()
      sigue = false
    } else if (txtFecha.current.value === '') {
      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar la Fecha', icono: 'informacion' });
      txtFecha.current.focus()
      sigue = false
    } else if (txtReferencia.current.value === '') {
      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar la Referencia', icono: 'informacion' });
      txtReferencia.current.focus()
      sigue = false
    } else if (txtMotivo.current.value === '') {
      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar el Motivo de Movimiento', icono: 'informacion' });
      txtMotivo.current.focus()
      sigue = false
    } else if (txtMonto.current.value === '' || txtMonto.current.value === '0,00') {
      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar el Monto de Movimiento', icono: 'informacion' });
      txtMonto.current.focus()
      sigue = false
    }


    if (sigue) {
      var movi = [];
      movi.push({
        idmovimientosentransito: txtIdMovimiento.current.value === '' ? 0 : txtIdMovimiento.current.value,
        idcuentabancaria: props.idcuentabancaria,
        fecha: txtFecha.current.value,
        fechasis: fechasistema,
        referencia: txtReferencia.current.value.toUpperCase(),
        motivo: txtMotivo.current.value.toUpperCase(),
        monto: txtMonto.current.value !== '' ? parseFloat(txtMonto.current.value.replace(/\./g, '').replace(',', '.')) : '0.00',
        tipo: cmbTipoMovimiento.current.value,
        conciliado: '0'
      })

      setBody({
        movimiento: movi
      });


      let msg = '';
      if (operacion === 1) {
        msg = 'Esta Seguro de Registrar estos Datos.';
      } else if (operacion === 2) {
        msg = 'Esta Seguro de Modificar estos Datos.';
      } else if (operacion === 3) {
        msg = 'Esta Seguro de Eliminar estos Datos.';
      }

      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
    }
  }

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/banco/actualizarmovimientostransito/${operacion}`;
    axios.post(endpoint, body, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (operacion === 1) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
        } else if (operacion === 2) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
        } else if (operacion === 3) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
        }
        setActivate(false);
      }
    }).catch(function (error) {
      let mensaje = '';
      if (error.response === undefined) {
        mensaje = 'Error de Conexion'
      } else {
        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
          mensaje = 'Ya existe un Registro con este rif'

        }
        else {
          mensaje = error.response.data.message
        }
      }
      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
      setActivate(false);
    })
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    procesarRegistro();
  };

  const blanquear = () => {
    setActivate(false);
    setBody(null);
    setHabilitado(false);

    //txtIdMovimiento.current.setAttribute("disabled", true);
    txtIdMovimiento.current.value = '';
    cmbTipoMovimiento.current.value = '';
    txtFecha.current.value = '';
    txtReferencia.current.value = '';
    txtMotivo.current.value = '';
    txtMonto.current.value = '';
  }

  const cancelar = () => {
    /*  blanquear(); */
    props.onHideCancela();

  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
        event.target.value = '0,00'
      }
      event.target.value = (formatoMonto(event.target.value));
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === '0' && char2 !== ',') {
        event.target.value = event.target.value.substring(1, event.target.value.legth);
      }
      if (event.which === 13) {
        btnAcepta.current.focus();
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onBotones = (op) => (e) => {

    e.preventDefault();

    if (op === 1) {
      setHabilitado(false);
      txtIdMovimiento.current.setAttribute("disabled", true);
      setTimeout(() => txtDescripcion.current.focus(), 200);

    } else if (op === 2) {
      txtIdMovimiento.current.removeAttribute("disabled");
      setHabilitado(false);
      txtIdMovimiento.current.focus();

    } else if (op === 3) {
      setHabilitado(true);
      txtIdMovimiento.current.removeAttribute("disabled")
      txtIdMovimiento.current.focus();
    } else if (op === 4) {
      setHabilitado(true);
      txtIdMovimiento.current.removeAttribute("disabled")
      txtIdMovimiento.current.focus();
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    } else if (op === 7) {
      cancelar();
    }
  }

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === 'fechadoc') {
        event.target.value = moment(event.target.value).format('YYYY-MM-DD');
        txtReferencia.current.focus();
      } else if (event.target.name === 'refe') {
        txtMotivo.current.focus();
      }

    } else if (typeof (event.which) === 'undefined') {
      if (event.target.name === 'fechadoc') {
        event.target.value = moment(event.target.value).format('YYYY-MM-DD');
      } else if (event.target.name === 'fechaingre') {
        event.target.value = moment(event.target.value).format('YYYY-MM-DD');
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;//alert(e.which);
  };


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setHabilitado(props.habilitado);
        if (props.operacion === 1) {
          txtIdMovimiento.current.value = props.idmovimiento;
          txtIdMovimiento.current.focus();
        } else {
          txtIdMovimiento.current.value = props.registro.idmovimientosentransito;
          cmbTipoMovimiento.current.value = props.registro.tipo;

          txtFecha.current.value = moment(props.registro.fecha).format('YYYY-MM-DD');
          txtReferencia.current.value = props.registro.referencia.trim();
          txtMotivo.current.value = props.registro.motivo.trim();
          txtMonto.current.value = formatMoneda(props.registro.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
          /*for (let i = 0; i < props.tipoingreso.length; i++) {
            if (props.tipoingreso[i].descripcion === props.registro.tipomovimiento) {
              cmbTipoMovimiento.current.selectedIndex = i;//props.tipoingreso[i].idtipo;
              break;
            }

          }*/

        }
      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <Modal.Title style={{ color: "#fff" }}>Incluir Movimiento.</Modal.Title>
        <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>
          <div className='border-azul col-md-12 py-3 rounded mx-auto'>

            <div className="row col-md-12 rounded mx-auto" style={{fontSizeAdjust: '0.6'}}>
              <div className="input-group input-group-sm mb-2 col-md-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">Id Movimiento:</label>
                <input type="text" disabled className="form-control bg-light" ref={txtIdMovimiento} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
              </div>
              <div className="input-group input-group-sm mb-2 col-md-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">Tipo Movimiento:</label>
                <select className="form-select form-select-sm " disabled={!habilitado} ref={cmbTipoMovimiento} aria-label=".form-select-sm example">
                  <option value="">--</option>
                  <option value='0' >Deposito</option>
                  <option value='1' >Transferencia</option>
                  <option value='2' >Nota Credito</option>
                  <option value='3' >Nota Debito</option>
                  <option value='4' >Cheque</option>
                </select>
              </div>
              <div className='col-md-3'></div>


              <div className="input-group input-group-sm mb-2 col-md-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">Fecha:</label>
                <input type="date" className="form-control bg-light" disabled={!habilitado} ref={txtFecha} defaultValue={moment(fechasistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name="fechadoc" onKeyUp={handleInputChange} onBlur={handleInputChange} />

              </div>
              <div className="input-group input-group-sm mb-2 col-md-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">Referencia:</label>
                <input type="text" className="form-control bg-light text-uppercase" disabled={!habilitado} ref={txtReferencia} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" name="refe" onKeyUp={handleInputChange} onBlur={handleInputChange} />

              </div>
              <div className="input-group input-group-sm mb-2 col-md-12">
                <label className="input-group-text" id="inputGroup-sizing-sm">Motivo:</label>
                <textarea type="area" className="form-control text-uppercase bg-light" disabled={!habilitado} ref={txtMotivo} name='motivo' onChange={onChange} style={{ height: 40 }} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

              </div>
              <div className='col-md-12 mx-auto row justify-content-end px-0'>
                <div className="input-group input-group-sm mb-2 col-md-3">
                  <label className="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Monto:</label>
                  <input type="text" className="form-control bg-light rounded text-right" defaultValue={'0,00'} disabled={!habilitado} ref={txtMonto} onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                </div>
              </div>

            </div>


          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className='col-md-5 row m-0 ml-auto'>
          <button ref={btnAcepta} disabled={operacion === 4 ? true : false} onClick={onBotones(5)} style={{ height: '27px' }} className="btn col mx-1 my-1 btn-sm rounded-pill btn-success "><i className="fas fa-check-circle" style={{ fontSize: '9px' }}>  Aceptar</i></button>
          <button ref={btnSalir} onClick={onBotones(7)} style={{ height: '27px' }} className="btn col mx-1 my-1 btn-danger btn-sm rounded-pill "><i className="fas fa-sign-out-alt" style={{ fontSize: '9px' }}> Cancelar</i></button>
        </div>
      </Modal.Footer>

    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/contabilidad/incluirMovimientosTransito.js